import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["roomTypeSelect", "itemWrapper", "roomTitle", "roomNameField", "itemGrid"]

  connect() {
    this.filterItems()
    this.connected = true
  }

  filterItems() {
    let roomTypeId = this.roomTypeSelectTarget.value

    this.itemWrapperTargets.forEach(wrapper => {
      const supportedRoomTypes = wrapper.dataset.roomTypes.split(',')

      if (roomTypeId && supportedRoomTypes.includes(roomTypeId)) {
        wrapper.style.display = 'block'
      } else {
        wrapper.style.display = 'none'
        // Reset quantity to 0 when hiding item type
        const quantityField = wrapper.querySelector('[data-inventory-stepper-target="quantityField"]')
        const quantityDisplay = wrapper.querySelector('[data-inventory-stepper-target="quantity"]')
        if (quantityField) quantityField.value = '0'
        if (quantityDisplay) quantityDisplay.textContent = '0'
      }
    })

    // Sort visible items by position for the selected room type
    if (roomTypeId && this.hasItemGridTarget) {
      this.sortItemsByPosition(roomTypeId)
    }

    // Only update room names after initial connection (because the server gave us the initial proper room names)
    if (this.connected) {
      document.dispatchEvent(new CustomEvent('room:update', {
        detail: { changedCard: this.element }
      }))
    }
  }

  sortItemsByPosition(roomTypeId) {
    const grid = this.itemGridTarget
    const wrappers = Array.from(this.itemWrapperTargets)

    wrappers.sort((a, b) => {
      const posA = this.getPositionForRoomType(a, roomTypeId)
      const posB = this.getPositionForRoomType(b, roomTypeId)
      return posA - posB
    })

    wrappers.forEach(wrapper => grid.appendChild(wrapper))
  }

  getPositionForRoomType(wrapper, roomTypeId) {
    const positions = wrapper.dataset.positions || ""
    const entries = positions.split(",")
    for (const entry of entries) {
      const [rtId, pos] = entry.split(":")
      if (rtId === roomTypeId) return parseInt(pos, 10)
    }
    return 9999
  }

  handleRoomTypeChanged() {
    this.updateRoomName()
  }

  updateRoomName() {
    if (!this.hasRoomTypeSelectTarget || !this.hasRoomTitleTarget || !this.hasRoomNameFieldTarget) return

    const roomTypeName = this.roomTypeSelectTarget.options[this.roomTypeSelectTarget.selectedIndex]?.text

    if (roomTypeName && roomTypeName !== "Select room type") {
      const generatedName = this.generateRoomName(roomTypeName)
      this.roomTitleTarget.textContent = generatedName
      this.roomNameFieldTarget.value = generatedName
    } else {
      this.roomTitleTarget.textContent = "New Room"
      this.roomNameFieldTarget.value = ""
    }
  }

  generateRoomName(roomTypeName) {
    // Count existing rooms of this type
    const allRoomCards = document.querySelectorAll('[data-controller="room-manager"]')

    // Get all cards of the same room type and sort them by position in DOM
    const sameTypeCards = []
    allRoomCards.forEach(card => {
      const roomTypeSelect = card.querySelector('[data-room-manager-target="roomTypeSelect"]')
      if (roomTypeSelect) {
        const selectedOption = roomTypeSelect.options[roomTypeSelect.selectedIndex]
        if (selectedOption && selectedOption.text === roomTypeName) {
          sameTypeCards.push(card)
        }
      }
    })

    // Sort by DOM position
    sameTypeCards.sort((a, b) => {
      return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1
    })

    // Find this card's position in the sorted list
    const position = sameTypeCards.indexOf(this.element) + 1

    return `${roomTypeName} ${position}`
  }
}
